<template>
  <span>
    &nbsp; <i :class="['far', expanded ? 'fa-angle-down' : 'fa-angle-right']"></i>&nbsp;
  </span>
</template>

<script>
export default {
  name: 'CollapsibleRowArrow',
  props: {
    expanded: Boolean
  }
}
</script>
